import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Modal } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const ForgotPassword = () => {
  const [data, setData] = useState({
    username: "",
    newPassword: "",
  });
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const navigate = useNavigate();
  const [timer, setTimer] = useState(300);
  const location = useLocation();


  useEffect(() => {
    let interval = null;
  
    if (isOtpModalOpen && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
  
    // Clean up on modal close or unmount
    return () => clearInterval(interval);
  }, [isOtpModalOpen, timer]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setFieldErrors({ ...fieldErrors, [e.target.name]: "" });
  };

  const validateFields = () => {
    const errors = {};
    if (!data.username.trim()) {
      errors.username = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(data.username)) {
      errors.username = "Enter a valid email address.";
    }
    return errors;
  };

  //   const validatePassword = () => {
  //     if (!data.newPassword.trim()) return "Password is required.";
  //     if (data.newPassword.length < 6)
  //       return "Password must be at least 6 characters.";
  //     return "";
  //   };

  const handleSendOtp = async () => {
    const errors = validateFields();
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    try {
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/send-password-reset-otp?email=${data.username}`
      );
      setIsOtpModalOpen(true);
      setTimer(300);
    } catch (error) {
      setError(error.response?.data?.Exception || "Failed to send OTP.");
    }
  };

  const handleChangePassword = async () => {
    // const passwordError = validatePassword();
    // if (passwordError) {
    //   setFieldErrors({ ...fieldErrors, newPassword: passwordError });
    //   return;
    // }

    if (!otp.trim()) {
      setFieldErrors({ ...fieldErrors, otp: "OTP is required." });
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/verify-otp-and-submit-new-password`,
        {
          username: data.username,
          newPassword: data.newPassword,
          otp,
        }
      );
      setIsOtpModalOpen(false);
      navigate("/");
    } catch (error) {
      setError(error.response?.data?.Exception || "Failed to reset password.");
    }
  };

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const sec = (seconds % 60).toString().padStart(2, "0");
    return `${min}:${sec}`;
  };

  return (
    <Box className="border-container">
      <form>
        <Typography variant="h4" textAlign={"center"} mb={5}>
          {location.pathname.includes("user-onboarding") ? "User Onboarding" : "Forgot Password"}
        </Typography>
        <Typography textAlign={"center"} mb={5}>
          Enter your registered email id to {location.pathname.includes("user-onboarding") ? "set" : "change"} your password
        </Typography>
        <input
          type="email"
          name="username"
          id="username"
          placeholder="Email"
          onChange={handleChange}
        />
        {fieldErrors.username && (
          <Typography
            sx={{
              color: "red",
              fontSize: "12px",
              lineHeight: "0.1rem",
              marginLeft: "25px",
            }}
          >
            {fieldErrors.username}
          </Typography>
        )}

        {error && <Typography sx={{ color: "red" }}>{error}</Typography>}
        {!location.pathname.includes("user-onboarding") &&
        <Typography sx={{ textAlign: "center" }}>
          <a href="/" style={{ fontSize: "14px" }}>
            Sign In
          </a>
        </Typography>}
        <Box className="btn-container">
          <Button className="btn-contained" onClick={handleSendOtp}>
            Submit
          </Button>
        </Box>
      </form>

      {/* OTP Modal */}
      <Modal open={isOtpModalOpen} onClose={() => setIsOtpModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" textAlign="center" mb={2}>
            Enter OTP
          </Typography>
          <input
            type="text"
            name="otp"
            id="otp"
            placeholder="OTP"
            onChange={(e) => setOtp(e.target.value)}
          />
          {fieldErrors.otp && (
            <Typography
              sx={{
                color: "red",
                fontSize: "12px",
                lineHeight: "0.1rem",
                marginLeft: "25px",
              }}
            >
              {fieldErrors.otp}
            </Typography>
          )}

          <input
            type="password"
            name="newPassword"
            id="password"
            placeholder="New Password"
            onChange={handleChange}
          />
          {fieldErrors.newPassword && (
            <Typography sx={{ color: "red", fontSize: "0.8rem" }}>
              {fieldErrors.newPassword}
            </Typography>
          )}
          <Typography fontSize="14px" mt={1}>
            Kindly check your email (including spam folder) for OTP.
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              mt: 1,
              color: "#ff1f1f",
            }}
          >
            {timer > 0 ? `OTP valid for: ${formatTime(timer)}` : "OTP expired"}
          </Typography>
          <Button
            className="btn-contained"
            fullWidth
            sx={{ mt: 3 }}
            onClick={handleChangePassword}
          >
            Submit
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default ForgotPassword;
